import useOnClickOutside from '@/hooks/useOnClickOutside';
import { useRef } from 'react';

type UseFloatingDropdownPanelParams = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Wires the click-outside behaviour for a select whose dropdown panel is portalled
 * to the document body (see {@link DropdownList} `isFloating`). Because the panel escapes
 * the trigger's DOM subtree, it is registered as an excluded ref so clicks inside it are
 * not treated as "outside".
 */
export function useFloatingDropdownPanel({ isOpen, onClose }: UseFloatingDropdownPanelParams) {
  const panelRef = useRef<HTMLElement | null>(null);
  const dropdownRef = useOnClickOutside(onClose, isOpen, { excludeRefs: [panelRef] });

  return { dropdownRef, panelRef };
}
